import { gsap } from "gsap";

const turboInputs = gsap.utils.toArray(
  document.querySelectorAll(".turbo-input")
);
turboInputs.forEach((wrap) => {
  // Elements
  wrap.innerHTML = wrap.innerHTML + '<span class="turbo-input-faux"></span>';
  const faux = wrap.querySelector(".turbo-input-faux");
  const input = wrap.querySelector("input");

  // Methods
  const append = (letter, caret) => {
    if (letter !== null) {
      faux.innerHTML =
        faux.innerHTML +
        '<span class="turbo-input-letter"><span>' +
        letter +
        "</span><span>" +
        letter +
        "</span></span>";
    }
    if (caret) {
      faux.innerHTML =
        faux.innerHTML + '<span class="turbo-input-caret"></span>';
    }
  };
  const syncInput = () => {
    setTimeout(() => {
      // Only allow alphanumeric, unscores, scpaes and dashes
      // input.value = input.value.replace(/[^a-zA-Z0-9_- ]/g, '').toUpperCase();
      const val = input.value;
      // Focus
      if (document.activeElement === input) {
        wrap.classList.add("--focus");
      } else {
        wrap.classList.remove("--focus");
      }
      // Add letters and caret
      faux.innerHTML = "";
      if (!val) {
        wrap.classList.remove("--turbo");
        // Placeholder
        if (document.activeElement !== input) {
          const placeholder = input.placeholder;
          placeholder.split("").forEach((letter) => {
            append(letter);
          });
        }
        append(null, true);
      } else {
        wrap.classList.add("--turbo");
        // Value
        const caretPos = input.selectionStart - 1;
        if (caretPos === -1) {
          append(null, true);
        }
        val.split("").forEach((letter, index) => {
          append(letter, index === caretPos);
        });
      }
      input.scrollLeft = "0px";
    }, 0); // resolve stack to fix caret position
  };

  // Events
  input.addEventListener("touchstart", syncInput);
  input.addEventListener("keydown", syncInput);
  input.addEventListener("click", syncInput);
  input.addEventListener("input", syncInput);
  input.addEventListener("focus", syncInput);
  input.addEventListener("blur", syncInput);
  input.focus(); // trigger focus on load
  syncInput();
});
